(function ($) {
  "use strict";
  $(function () {
    var ANIMATION_SPEED = 150;

    $(".js-pm-faq-question").on("click", function () {
      var $question = $(this);
      var $item = $question.closest(".pm-faq__item");
      var $list = $question.closest(".js-pm-faq-list");
      var wasActive = $item.hasClass("pm-faq__item--active");

      $list
        .find(".pm-faq__item--active")
        .not($item)
        .removeClass("pm-faq__item--active")
        .find(".js-pm-faq-question")
        .attr("aria-expanded", "false")
        .end()
        .find(".js-pm-faq-answer")
        .slideUp(ANIMATION_SPEED);

      if (wasActive) {
        $item.removeClass("pm-faq__item--active");
        $question.attr("aria-expanded", "false");
        $item.find(".js-pm-faq-answer").slideUp(ANIMATION_SPEED);
      } else {
        $item.addClass("pm-faq__item--active");
        $question.attr("aria-expanded", "true");
        $item.find(".js-pm-faq-answer").slideDown(ANIMATION_SPEED);
      }
    });
  });
})(jQuery);
